import React, {forwardRef, ReactNode, RefObject, useCallback, useEffect, useRef} from "react";
import styled from "@emotion/styled";
import {Portal} from "../Portal";

interface ModalProps {
  open: boolean
  onClose: () => void
  containerRef?: RefObject<HTMLElement>;

  disablePortal?: boolean,

  children?: ReactNode

}


const Modal = forwardRef<Element, ModalProps>((
  props,
  ref
) => {
  const {
    open,
    onClose,
    children,
    containerRef,
    disablePortal,
  } = props

  const contentRef = useRef<HTMLDivElement>(null);


  const handleClose = useCallback((event: KeyboardEvent) => {
    const key = event.key;
    if (key === 'Escape' || key === 'Esc') {
      onClose()
    }
  }, [onClose])

  useEffect(() => {
    document.addEventListener('keyup', handleClose);
    return () => {
      document.removeEventListener('keyup', handleClose)
    }
  }, [handleClose])


  return (
    <Portal
      ref={ref}
      containerRef={containerRef}
      visible={open}
      disablePortal={disablePortal}
      keepMounted={false}
    >
      <ModalRoot ref={contentRef}>
        <Backdrop onClick={onClose}/>
        <ModalContainer>
          {children}
        </ModalContainer>
      </ModalRoot>
    </Portal>
  )
});

export {Modal};

const ModalRoot = styled.div`
  position: fixed;
  z-index: var(--zIndex100);
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`

const Backdrop = styled.div`
  z-index: -1;
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-tap-highlight-color: transparent;
`;

const ModalContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`
